<script setup>
import { ref, watch, onMounted, inject } from 'vue';
import transporte from '@/api/transporte';
import { isValidDate } from '../../../libs/dates';

const I18n = inject('I18n');

const props = defineProps({
  turnoId: { type: [Number, Array], default: () => [] },
  fechaInicio: { type: String, default: null },
  fechaFin: { type: String, default: null },
  conservarAsientoInicial: { type: Boolean, default: true },
  modelValue: { type: Number, default: null },
});

const emit = defineEmits(['update:modelValue']);

const asientoFijo = ref(props.conservarAsientoInicial ? props.modelValue : null);
const asientosLibres = ref([]);

const loadAsientos = () => {
  if (!props.turnoId) {
    return;
  }

  let turnoIds;
  if (Array.isArray(props.turnoId)) {
    turnoIds = props.turnoId;
  } else {
    turnoIds = [props.turnoId];
  }

  if (!turnoIds.length || !isValidDate(new Date(props.fechaInicio))) {
    return;
  }

  transporte.turnos.asientosLibres(turnoIds, props.fechaInicio, props.fechaFin).then((result) => {
    asientosLibres.value = result.data.asientos_libres;
    if (asientoFijo.value) {
      anadirAsiento(asientoFijo.value);
    }

    if (props.modelValue) {
      if (!asientosLibres.value.includes(props.modelValue)) {
        // Si se recarga y ya no existe el asiento inicial, eliminamos el valor
        emit('update:modelValue', null);
      }
    }
  });
};

const anadirAsiento = (numero) => {
  if (!asientosLibres.value.includes(numero)) {
    asientosLibres.value.push(numero);
    asientosLibres.value = asientosLibres.value.sort((a, b) => a - b);
  }
};

const seleccionarAsiento = (asiento) => {
  emit('update:modelValue', asiento);
};

watch(
  () => props.turnoId,
  () => {
    loadAsientos();
  },
);

watch(
  () => props.fechaInicio,
  () => {
    loadAsientos();
  },
);

watch(
  () => props.fechaFin,
  () => {
    loadAsientos();
  },
);

onMounted(() => {
  loadAsientos();
});
</script>

<template>
  <div class="clearfix">
    <span
      v-for="asiento in asientosLibres"
      :key="asiento"
      class="asiento-control label clickable m-r-sm pull-left"
      :class="{ 'label-white': asiento != modelValue, 'label-cifra': asiento == modelValue }"
      @click="seleccionarAsiento(asiento)"
    >
      {{ asiento }}
    </span>
    <span
      v-if="!asientosLibres.length"
      class="form-control"
    >
      {{ $I18n.t('asientos_no_disponibles') }}
    </span>
  </div>
</template>
